export default __webpack_public_path__ + "static/media/logo-light.1ddaa96c.png";